import { useCallback, useState } from 'react';
import { useTranslation } from 'react-i18next';

import { CREATE_JOB_COMPANY_CONTACT_MUTATION } from 'src/graphql/jobExternalStakeholders/mutation';
import { notification } from 'src/components/Notification';
import { useMutation } from 'src/graphql';

export const useCreateJobCompanyContact = () => {
  const [createJobCompanyContact] = useMutation(CREATE_JOB_COMPANY_CONTACT_MUTATION);

  const [isLoading, setIsLoading] = useState(false);
  const { t } = useTranslation();

  const createJobCompanyContactCallback = useCallback(async ({
    companyId,
    firstName,
    lastName,
    email
  }) => {
    setIsLoading(true);

    try {
      const response = await createJobCompanyContact({
        variables: {
          companyId,
          firstName,
          lastName,
          email
        },
      });

      setIsLoading(false);

      if (!response?.data?.createJobCompanyContact?.success) {
        notification.error(t('ERROR_OCCURED'));
        return false;
      }

      return true;

    } catch (e) {
      notification.error(t('ERROR_OCCURED'));
      setIsLoading(false);
      return false;
    }
  }, [],
  );

  return {
    createJobCompanyContactCallback,
    isLoading,
  };
};
